module.exports = __webpack_public_path__ + "img/1.a5f8dc77.png";